import React, { Component } from "react";
import { push } from "../Services/Analytics"
import { ManotApi } from "../Services/fetchService"
import Loading from "../Services/Loading/Loading"
import FalafelMeal from "./ManaFalafel.Meal"

import "./ManotFalafel.scss"

class ManotFalafel extends Component {
  constructor() {
    super()
    this.state = {
      items: []
    }
  }
  async componentDidMount() {
    await this.props.showLoader();
    this.setState({
      items: await ManotApi.get()
    })
    await this.props.showLoader();
  }

  getItems() {
    return this.state.items.map((item, index) =>
      <FalafelMeal key={index}
        index={index}
        chooseMeal={this.props.chooseMeal}
        triggerPopup={this.props.triggerPopup}
        removeSelected={this.props.removeSelected}
        current={this.props.current}
        getMeal={this.props.getMeal}
        item={item}
      />
    )
  }
  render() {
    return (
      <section className="section section-manotfalafel">
        <div className="padding">
          <div className="container">
            <Loading showLoading={this.props.isLoading} />
            <div className="manot">
              {this.getItems()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ManotFalafel;



// WEBPACK FOOTER //
// ./src/Components/ManotFalafel/ManotFalafel.jsx